angular.module('GatorPad.controllers.Feed', [])

.controller('FeedController', ['$rootScope', '$scope', 'ApiService', 'moment', function($rootScope, $scope, ApiService, moment){
  $scope.farmList = [];
  $scope.barnList = [];
  $scope.tankList = [];
  $scope.entryDate = new Date();
  $scope.entryDate.setHours(0,0,0,0);
  
  if (navigator.onLine) {
    ApiService.initializeData()
      .then(function () {
        $scope.farmList = ApiService.getFarms();
      }, function (err) {
        $scope.error = "Could not load " + err + " data.";
      });
  } else {
    $scope.farmList = ApiService.getFarms();
  }
      

  $scope.selectBarn = function() {
      $scope.tankList = [];
      
      if ($scope.selectedBarn) {
        var entryDateMoment = moment($scope.entryDate);
        if ($scope.selectedBarn.feedSchedule) {
          var feedScheduleArray = $scope.selectedBarn.feedSchedule.filter(function(a) {
            var checkDate = moment(a.startDate);
            if (entryDateMoment.isAfter(checkDate) || entryDateMoment.isSame(checkDate)) {
              return true;
            } else {
              return false;
            }
          });
          
          if (feedScheduleArray && feedScheduleArray.length >= 1) {
            $scope.todaysFeed = feedScheduleArray[feedScheduleArray.length - 1];
          }
        }
        
        angular.forEach(ApiService.getTanks($scope.selectedBarn.id), function (tank) {
          var tankData = window.localStorage.getItem("FEED." + $scope.entryDate.toDateString() + "." + $scope.selectedFarm.id + "." + $scope.selectedBarn.id + "." + tank.id);
          if (tankData) {
            tankData = JSON.parse(tankData);
            $scope.tankList.push({id:tank.id, name:tank.name, physicalTankCount: tankData.physicalTankCount, feedAdded:tankData.feedAdded, feedType:tankData.feedType, feedQuantity:tankData.feedQuantity});
          } else {
            $scope.tankList.push({id:tank.id, name:tank.name, physicalTankCount: tank.physicalTankCount, feedAdded:true, feedType:$scope.todaysFeed.feedType.name, feedQuantity:$scope.todaysFeed.tankFeedQuantity * tank.physicalTankCount});
          }
        });
      }
  };
  
  $scope.save = function() {
    angular.forEach($scope.tankList, function(tank) {
      var storageKey = "FEED." + $scope.entryDate.toDateString() + "." + $scope.selectedFarm.id + "." + $scope.selectedBarn.id + "." + tank.id;
      if (tank.feedAdded) {
        var storageValue = JSON.stringify({entryDate: $scope.entryDate, entryDateDisplay: $scope.entryDate.toDateString(), farmName:$scope.selectedFarm.name, barnName:$scope.selectedBarn.name, barnId:$scope.selectedBarn.id, tankName:tank.name, tankId:tank.id, physicalTankCount:tank.physicalTankCount, feedType:tank.feedType, feedQuantity:tank.feedQuantity, feedAdded:true});
        window.localStorage[storageKey] = storageValue;
      } else {
        window.localStorage.removeItem(storageKey);
      }
    });

    $scope.saveModalTitle = "Feed Save";
    $scope.saveModalBody = "The feed amounts have been saved.";
    $rootScope.Ui.turnOn('modalSave');
  };
  
}]);